import React, { useMemo } from 'react'
import LinkButton from '@active/react-ui/LinkButton'
import EmailInputWithBadListCheck from '../EmailInputWithBadListCheck'
import I18nMessage from '../I18nMessage'

function EmailInputWithErrorContent({
  name,
  inputValue,
  handleChange,
  changeExistAccount,
  checkedResultState = {},
  hasError: hasErrorFromProp,
  ...emailInputProps
}) {
  const hasError = useMemo(
    () => !!checkedResultState.existAccount || hasErrorFromProp, [checkedResultState, hasErrorFromProp])

  return (
    <div className="mg-r-0 mg-l-0 passport__checkemail">
      <EmailInputWithBadListCheck
        id={name}
        name={name}
        value={inputValue}
        onChange={handleChange}
        autoComplete="email"
        {...emailInputProps}
        hasError={hasError}
      />
      {!!checkedResultState.existAccount && (
        <div className="form-group-error text-font-14 passport-check_email-existAccount">
          <i className="ic-cross-r" />
          <span aria-live="assertive">
            <I18nMessage id="passport.signup.notice.existAccount" className="red" />
            <LinkButton className="passport-check_email-login" tabIndex={0} onClick={() => changeExistAccount && changeExistAccount(inputValue)}>
              <I18nMessage id="passport.common.btn.signIn" />
            </LinkButton>
          </span>
        </div>
      )}
    </div>
  )
}

export default EmailInputWithErrorContent
